import jsPDF from "jspdf";
import { party1Of, contractSections } from "@/lib/partner";

let logoCache = null;
async function loadLogo() {
  if (logoCache) return logoCache;
  const res = await fetch("/logo-letterhead.png");
  const blob = await res.blob();
  logoCache = await new Promise((resolve) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.readAsDataURL(blob);
  });
  return logoCache;
}

function letterhead(doc, logo) {
  const pw = doc.internal.pageSize.getWidth();
  if (logo) {
    const w = 96;
    const h = (w * 222) / 353;
    doc.addImage(logo, "PNG", (pw - w) / 2, 26, w, h);
  }
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(120);
  doc.text("bedsolvingindonesia@gmail.com  ·  ops.bedsolving.id  ·  Bali, Indonesia", pw / 2, 104, { align: "center" });
  doc.setDrawColor(217, 102, 53);
  doc.setLineWidth(1.6);
  doc.line(48, 116, pw - 48, 116);
  doc.setTextColor(30);
}

function renderDoc(doc, type, data, startY) {
  const s = contractSections(type, data);
  const P1 = party1Of(data);
  const pw = doc.internal.pageSize.getWidth();
  const margin = 48;
  const maxw = pw - margin * 2;
  let y = startY;

  const ensure = (h) => {
    if (y + h > doc.internal.pageSize.getHeight() - 60) {
      doc.addPage();
      y = 56;
    }
  };

  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(s.title, pw / 2, y, { align: "center" });
  y += 16;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(s.subtitle, pw / 2, y, { align: "center" });
  doc.setTextColor(30);
  y += 22;

  // parties
  doc.setFontSize(9);
  const p1 = [`Party 1`, `Name: ${P1.name}`, `Title: ${P1.title}`, `Contact: ${P1.contact}`, `Company: ${P1.company}`];
  const p2 = [`Party 2`, `Name: ${data.partner_name || "-"}`, `Title: ${data.partner_title || "-"}`, `Contact: ${data.partner_contact || "-"}`, `Company: ${data.partner_company || "-"}`];
  doc.setFont("helvetica", "bold");
  doc.text(p1[0], margin, y);
  doc.text(p2[0], pw / 2 + 10, y);
  doc.setFont("helvetica", "normal");
  p1.slice(1).forEach((t, i) => doc.text(t, margin, y + (i + 1) * 12));
  p2.slice(1).forEach((t, i) => doc.text(t, pw / 2 + 10, y + (i + 1) * 12));
  y += p1.length * 12 + 14;

  doc.setFontSize(10);
  s.blocks.forEach((b) => {
    ensure(20);
    if (b.heading) {
      doc.setFont("helvetica", "bold");
      doc.text(b.heading, margin, y);
      doc.setFont("helvetica", "normal");
      y += 14;
    }
    (b.paragraphs || []).forEach((t) => {
      const lines = doc.splitTextToSize(t, maxw - (b.heading ? 6 : 0));
      ensure(lines.length * 13 + 4);
      doc.text(lines, margin + (b.heading ? 6 : 0), y);
      y += lines.length * 13 + 4;
    });
    (b.items || []).forEach((t) => {
      const lines = doc.splitTextToSize(`\u2022 ${t}`, maxw - 10);
      ensure(lines.length * 13 + 4);
      doc.text(lines, margin + 6, y);
      y += lines.length * 13 + 4;
    });
    y += 4;
  });

  // signatures
  ensure(100);
  y += 8;
  doc.setFontSize(9);
  doc.text(`Authorized representative - ${P1.name}`, margin, y);
  doc.text(`Authorized representative - ${data.partner_name || "Partner"}`, pw / 2 + 10, y);
  const sigY = y + 6;
  try {
    if (data.admin_signature) doc.addImage(data.admin_signature, "PNG", margin, sigY, 120, 46);
    if (data.partner_signature) doc.addImage(data.partner_signature, "PNG", pw / 2 + 10, sigY, 120, 46);
  } catch (e) { /* ignore bad image */ }
  y = sigY + 52;
  doc.line(margin, y, margin + 150, y);
  doc.line(pw / 2 + 10, y, pw / 2 + 160, y);
  y += 12;
  doc.setFontSize(8);
  doc.setTextColor(120);
  doc.text(data.admin_signed_at ? new Date(data.admin_signed_at).toLocaleDateString("en-GB") : "", margin, y);
  doc.text(data.partner_signed_at ? new Date(data.partner_signed_at).toLocaleDateString("en-GB") : "", pw / 2 + 10, y);
  doc.setTextColor(30);
  y += 20;
  doc.setFontSize(8);
  doc.setTextColor(150);
  doc.text("TRUSTED PARTNER SINCE 2014", pw / 2, y, { align: "center" });
  doc.setTextColor(30);
}

export async function downloadPartnerPdf(data) {
  const logo = await loadLogo().catch(() => null);
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  letterhead(doc, logo);
  renderDoc(doc, "agreement", data, 140);
  doc.addPage();
  letterhead(doc, logo);
  renderDoc(doc, "authorization", data, 140);
  const safe = (data.property_name || data.partner_name || "partner").replace(/[^a-z0-9]+/gi, "_");
  doc.save(`partnership_${safe}.pdf`);
}
